
import React from "react";
import { ChartContainer } from "@/components/ui/chart";
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

interface RevenueChartProps {
  data: {
    name: string;
    "Receita (R$)": number;
  }[];
}

const RevenueChart: React.FC<RevenueChartProps> = ({ data }) => {
  return (
    <ChartContainer config={{
      revenue: { label: "Receita (R$)", color: "rgb(16, 185, 129)" },
    }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="Receita (R$)" 
            stroke="rgb(16, 185, 129)" 
            strokeWidth={2}
            activeDot={{ r: 8 }} 
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};

export default RevenueChart;
